/** Composes task form handler hooks into a single handlers object. */
import { useTaskFormFieldHandlers } from '@/features/tasks/hooks/form/use-task-form-field-handlers';
import { useTaskFormSubmitHandlers } from '@/features/tasks/hooks/form/use-task-form-submit-handlers';

export const useTaskFormHandlers = ({
  task,
  setTask,
  allTasks,
  isRollup,
  validate,
  onSave,
  setIsSubmitting,
}) => {
  const fieldHandlers = useTaskFormFieldHandlers({
    setTask,
    allTasks,
    isRollup,
  });
  const submitHandlers = useTaskFormSubmitHandlers({
    task,
    setTask,
    validate,
    onSave,
    setIsSubmitting,
  });

  return { ...fieldHandlers, ...submitHandlers };
};
